import { call, put, takeEvery } from "redux-saga/effects";
import { ViewPostConstants } from "../constants/viewPost.constants";
import { doGraphQLQuery, handleFailure } from "./graphql.saga";
import {
    fetchPostFailure,
    fetchPostSuccess
} from "../actions/viewPost.actions";
import { postContents } from "./query.helper";
import { setOpenedAt } from "../actions/notifications.actions";

export function* fetchPost() {
    yield takeEvery(ViewPostConstants.FETCH_POST, doFetchPost);
}

function* doFetchPost({ payload: { id } }) {
    try {
        const query = `{
            post(id: ${JSON.stringify(id)}) ${postContents}
        }`;
        const results = yield call(doGraphQLQuery, query);
        yield put(fetchPostSuccess(results));
        yield put(setOpenedAt({ id }));
    } catch (e) {
        yield call(handleFailure, e, fetchPostFailure);
    }
}



// WEBPACK FOOTER //
// ./src/sagas/viewPost.saga.js